import { useEffect, useState } from 'react'

import GetUrls from 'ts/enums/Url'
import { SubClass, Option, Class } from 'ts/types'
import useModalStore from 'store/modal'
import { CheckBoxToggle, Input, Select } from 'components/ui'
import useModalForm from 'hooks/useModalForm'
import useFetchSafe from 'hooks/useFetchSafe'


const SubClassAddPage = () => {
  const Url = GetUrls();
  const params = useModalStore((state) => state.params) as SubClass
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form
  const [isActive, setIsActive] = useState<boolean>(true);
  const [ options, setOptions] = useState<Option[]>([])
  const { data } = useFetchSafe<Class>(Url.getClass)

  useEffect(() => {
    console.log("params", params)
    if (params) {
      setValue('subclassId', params.subclassId)
      setIsActive(params.flActive);
    }
    if(data) {
      setOptions(
        data.map((classOpt) => ({
          value: classOpt.classId,
          children: classOpt.name
        })) 
      )
    }
  }, [data, params, setValue])

  const handleToggleActive = (isChecked: boolean) => {
    setIsActive(isChecked);
  }

  return (
    <ModalForm
      // config={{ url: params ? Url.updateSubclass : Url.postSubclass, method: params ? 'PUT' : 'POST' }}
      config={{ url: Url.postSubclass, method: params ? 'PUT' : 'POST' }}
      // altApiCall={{ url: params ? Url.updateSubclassAlt : Url.postSubclassAlt, method: params ? "PUT" : "POST" }}
      title={ `${params ? 'Edit ' : 'Create ' }Sub Class` }
      description='Create or edit a Sub Class'
    >
      {params ? (
        <Input defaultValue={params.subclassId} label="ID" disabled className='hidden' />
      ) : null}
        <CheckBoxToggle 
          label="Active" 
          defaultChecked={isActive} 
          onToggle={handleToggleActive}
        />
        <Input
          label="Active" 
          className='hidden'
          {...register("flActive", { value : isActive ? 1 : 0 })}
        />
      <Input
        defaultValue={ params?.name || '' }
        label="Sub Class Name"
        {...register('name', { required: true })}
      />
      {options.length > 0 ?
        <Select
            defaultValue={ params?.classId.toString() || '' }
            label="Class"
            placeholder='Select a Class...'
            options={options}
            {...register('classId', { valueAsNumber: true })}
        />
       :
       <Select
          disabled
          className='opacity-70'
          label="Class"
          defaultValue={"placeholder"}
          options={[{ value:"loading", children:"Loading..." }]}
        />
      }

    </ModalForm>
  )
}

export default SubClassAddPage
